import getIsRecognizedPromises from '../helpers/get-is-recognized-promises';
import OrchCustomData from '../helpers/orch-custom-data';
import { initSdk } from './init';

/**
 * reinitializeOrchSdk function will be called by merchant sdk to update
 * correlationId and sessionId to all src-sdks
 * @param {string} reinitCorrelationId
 * @param {string} reinitSessionId
 * @return {Promise}
 */
const reinitializeOrchSdk = (reinitCorrelationId, reinitSessionId) => {
  // ensure response cache is clear before another init call
  OrchCustomData.clearApiResponseCache();
  OrchCustomData.srcSdks.isRecognizedPromiseArr = [];
  OrchCustomData.initSuccessfulNetworks = [];

  const configs = window.VsbOrchAdapterInstance.configs;
  configs.correlationId = reinitCorrelationId;
  configs.sessionId = reinitSessionId;
  const loadedSdk = OrchCustomData.srcSdks.loadedSdk;
  OrchCustomData.srcSdks.orchConfig.preferredNetwork = '';
  OrchCustomData.srcSdks.orchConfig.windowReference = null;

  return Promise.all(
    Object.keys(loadedSdk).map(network => {
      const sdkInstance = loadedSdk[network];

      // call src-sdk init() with updated correlationId and sessionId
      return initSdk(configs, sdkInstance, network, OrchCustomData.srcInitiatorId[network]);
    })
  ).then(responses => {
    getIsRecognizedPromises(responses).then(() => {
      window.V?.orchReady?.();
    });
  });
};

export default reinitializeOrchSdk;
